import { render, staticRenderFns } from "./withdrawDemo.vue?vue&type=template&id=51c99a1f&scoped=true&"
import script from "./withdrawDemo.vue?vue&type=script&lang=js&"
export * from "./withdrawDemo.vue?vue&type=script&lang=js&"
import style0 from "./withdrawDemo.vue?vue&type=style&index=0&id=51c99a1f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c99a1f",
  null
  
)

export default component.exports